import {
  FrequenciaTipoEnum
} from '../../../../../enum/lancamento-aula/frequencia-tipo.enum';
import {
  IRelatorioFrequenciaSkillDTO
} from '../../../../../models/happy-code-api.model';
import {
  BaseFrequenciaSkillFormInterface
} from '../../../interfaces/base-frequencia-skill-form.interface';

export default function useEnumMapper() {
  const frequenciaTipoEnumToNumber = (tipo: FrequenciaTipoEnum): number => {
    switch (tipo) {
      case FrequenciaTipoEnum.PRESENTE:
        return 1;
      case FrequenciaTipoEnum.ATRASADO:
        return 3;
      case FrequenciaTipoEnum.AUSENTE:
        return 2;
      default:
        return 1;
    }
  };

  const stringToFrequenciaTipo = (tipo: string) => {
    if (!tipo) return FrequenciaTipoEnum.PRESENTE;

    switch (tipo) {
      case 'PRE':
        return FrequenciaTipoEnum.PRESENTE;
      case 'ATR':
        return FrequenciaTipoEnum.ATRASADO;
      case 'AST':
        return FrequenciaTipoEnum.AUSENTE;
      default:
        return FrequenciaTipoEnum.PRESENTE;
    }
  };

  const relatorioFrequenciaSkillDtoToBaseFrequenciaSkillFormInterface = (
    dto: IRelatorioFrequenciaSkillDTO
  ): BaseFrequenciaSkillFormInterface => {
    const observacao = (dto as any)?.frequencia?.descricaoAlunoAula
      || (dto as any)?.descricaoAlunoAula
      || '';

    const projetoLink = (dto as any)?.projeto?.link
      || (dto as any)?.frequencia?.link
      || (dto as any)?.frequencia?.projetoLink
      || (dto as any)?.frequencia?.linkProjeto;

    const projetoValue = (dto as any)?.projeto?.value
      ?? (dto as any)?.frequencia?.value
      ?? (dto as any)?.frequencia?.numeroNota
      ?? (dto as any)?.frequencia?.notaProjeto;
    const projetoNomeArquivo = (dto as any)?.projeto?.nomeArquivo
      || (dto as any)?.frequencia?.nomeArquivo
      || (dto as any)?.frequencia?.projetoNomeArquivo
      || (dto as any)?.frequencia?.nomeArquivoProjeto;

    return {
      presenca: stringToFrequenciaTipo(dto?.frequencia?.tipo),
      observacao,
      projetoLink,
      projetoValue,
      projetoNomeArquivo
    };
  };

  return {
    frequenciaTipo: {
      toNumber: frequenciaTipoEnumToNumber
    },
    relatorioFrequenciaSkillDtoToBaseFrequenciaSkillFormInterface
  };
}
